import { defineAction, object, string, array, enumerated } from '~/prix'
import insightExportAction from './buildInsightsExport.action.json' with { type: 'json' }

const insightExportDefinition = defineAction({
  ...insightExportAction,
  input: object({
    search: string().isOptional(),
    delimitation: string().isOptional(),
    productName: string().isOptional(),
    alertType: array(string()).isOptional(),
    alertPreset: string().isOptional(),
    portfolio: string().isOptional(),
    sortBy: string().isOptional(),
    sortOrder: string().isOptional(),
    format: enumerated({
      xlsx: 'xlsx',
      csv: 'csv',
    }),
  }),

  output: object({}),
})

export default insightExportDefinition